"use client"

import * as React from "react"

export function DevToolsGuard() {
  React.useEffect(() => {
    function onContextMenu(event: MouseEvent) {
      event.preventDefault()
    }

    function onKeyDown(event: KeyboardEvent) {
      if (event.key === "F12") {
        event.preventDefault()
      }
    }

    document.addEventListener("contextmenu", onContextMenu)
    window.addEventListener("keydown", onKeyDown)

    return () => {
      document.removeEventListener("contextmenu", onContextMenu)
      window.removeEventListener("keydown", onKeyDown)
    }
  }, [])

  return null
}
